import { Kommune } from '@/domain/omrader';
import { transformGeometri } from './geometri';
import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';
import type {
    Geometri as ApiGeometri,
    Vegobjekt as ApiVegobjekt,
} from '@/generated/nvdb/vegobjekter/models';

export type KommuneApiResponse = {
    navn: string;
    nummer: number;
    fylke: number;
    kartutsnitt: ApiGeometri;
    senterpunkt: ApiGeometri;
    vegobjekt: Pick<ApiVegobjekt, 'id'> & {
        type: number;
    };
};

export function transformKommuner(kommunerResponse: KommuneApiResponse[]): Kommune[] {
    return kommunerResponse.map(kommune => transformKommune(kommune));
}

export function transformKommune(data: null | undefined): null;
export function transformKommune(data: KommuneApiResponse): Kommune;
export function transformKommune(
    data: KommuneApiResponse | null | undefined
): Kommune | null {
    return data
        ? new Kommune(
              data.navn,
              data.nummer,
              data.fylke,
              transformGeometri(data.kartutsnitt),
              transformGeometri(data.senterpunkt),
              Vegobjekt.dummy(data.vegobjekt.id, data.vegobjekt.type)
          )
        : null;
}
